import { SvgIcon } from "@mui/material";

// Eye Icon
export function ScrollListIcon(props) {
  return (
    <SvgIcon
      sx={{
        fill: "red",
      }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={"red"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.32031 8.6279L7.04195 5.90625M7.04195 5.90625L9.76361 8.6279M7.04195 5.90625V18.6074M7.04195 18.6074L4.32031 15.8858M7.04195 18.6074L9.76361 15.8858"
        stroke={props.color || "#000000"}
        stroke-width="1.44"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.4531 12.3479H19.6768M13.4531 17.8282H19.6768M13.4531 6.68359H19.6768"
        stroke={props.color || "#000000"}
        stroke-width="1.44"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
}
